import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateUtil {
  constructor() { }
  public static getZDate(dateString) {
    if (dateString != null) {
      // dateString = dateString + "";
      console.log(dateString);
      if (dateString.indexOf("Z") > -1) {
        return new Date(dateString + "");
      } else {
        return new Date(dateString + "Z");
      }
    } else {
      return null;
    }
  }
  public static convertNumberToStringDate(dateNumber: number) {
    let date = new Date(dateNumber);
    let month: string = date.getMonth() + 1 + '';
    if (month.length == 1) {
      month = '0' + month;
    }
    let day: string = date.getDate() + '';
    if (day.length == 1) {
      day = '0' + day;
    }
    return day + " " + this.getMonthString("" + month) + " " + date.getHours() + ":" + date.getMinutes();
  }

  public static convertDateToStringDate(date: any) {
    console.log(typeof date, date);
    if (typeof date === 'string') {
      return date;
    } else {
      let month: string = date.getMonth() + 1 + '';
      if (month.length == 1) {
        month = '0' + month;
      }
      let day: string = date.getDate() + '';
      if (day.length == 1) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    }

  }
  public static convertDateToStringDateTime(date: Date) {
    console.log(typeof date, date);
    if (typeof date === 'string') {
      return date;
    } else {
      let month: string = date.getMonth() + 1 + '';
      if (month.length == 1) {
        month = '0' + month;
      }
      let day: string = date.getDate() + '';
      if (day.length == 1) {
        day = '0' + day;
      }
      let hr: string = date.getHours() + '';
      if (hr.length == 1) {
        hr = '0' + hr;
      }
      let min: string = date.getMinutes() + '';
      if (min.length == 1) {
        min = '0' + min;
      }
      console.log("after conversion", date.getFullYear() + '-' + month + '-' + day + "T" + hr + ":" + min);
      return date.getFullYear() + '-' + month + '-' + day + "T" + hr + ":" + min;
    }
  }


  convertDateToStringTime(date: Date) {
    return date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
  }

  public static convertStringToDate(stringDate: any): Date {
    if (!stringDate) {
      return new Date();
    }
    if (stringDate.includes("-")) {
      let splittedDate = stringDate.split('-');
      let date: Date = new Date();
      date.setFullYear(parseInt(splittedDate[0]), parseInt(splittedDate[1]) - 1, parseInt(splittedDate[2]));
      return date;
    } else {
      let splittedDate = stringDate.split('/');
      let date: Date = new Date();
      date.setFullYear(parseInt(splittedDate[2]), parseInt(splittedDate[1]) - 1, parseInt(splittedDate[0]));
      return date;
    }
  }
  public static convertTimeStringToDate(stringDate: string): Date {
    let date: Date = new Date();
    let stringTime = stringDate.split('T')[1];
    stringDate = stringDate.split('T')[0];
    let splittedDate = stringDate.split('-');
    date.setFullYear(parseInt(splittedDate[0]), parseInt(splittedDate[1]) - 1, parseInt(splittedDate[2]));

    // date.setDate(parseInt(stringDate.split('-')[2]));
    // date.setMonth(parseInt(stringDate.split('-')[1]) - 1);
    // date.setFullYear(parseInt(stringDate.split('-')[0]));
    if (stringTime) {
      date.setHours(parseInt(stringTime.split(':')[0]), parseInt(stringTime.split(':')[1]));
    }

    return date;
  }

  public static convertddmmyyyyToDate(stringDate: string): Date {
    let date: Date = new Date();
    date.setDate(parseInt(stringDate.split('-')[0]));
    date.setMonth(parseInt(stringDate.split('-')[1]) - 1);
    date.setFullYear(parseInt(stringDate.split('-')[2]));
    return date;
  }



  public static getMonthString(month: string) {
    switch (parseInt(month)) {
      case 1:
        return ' Jan ';
      case 2:
        return ' Feb ';
      case 3:
        return ' Mar ';
      case 4:
        return ' Apr ';
      case 5:
        return ' May ';
      case 6:
        return ' Jun ';
      case 7:
        return ' Jul ';
      case 8:
        return ' Aug ';
      case 9:
        return ' Sep ';
      case 10:
        return ' Oct ';
      case 11:
        return ' Nov ';
      case 12:
        return ' Dec ';
    }
  }


  public static convertOldDate(dbDate: number) {
    let displayDate: Date = new Date();

    displayDate.setFullYear(parseInt((dbDate + "").substr(0, 4)), parseInt((dbDate + "").substr(4, 2)), parseInt((dbDate + "").substr(6, 2)));
    displayDate.setHours(parseInt((dbDate + "").substr(8, 2)), parseInt((dbDate + "").substr(10, 2)), parseInt((dbDate + "").substr(12, 2)));

    // console.log("" + parseInt((dbDate + "").substr(0, 4)) + ":" + parseInt((dbDate + "").substr(4, 2)) + ":" + parseInt((dbDate + "").substr(6, 2)));

    // console.log(dbDate + " : " + displayDate.toString());
    return displayDate.getTime();
  }
}
